import { v4 as uuid } from 'uuid';
import { isListNotEmpty, isNumberGreaterThanOrEqualToZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

class OrderShipment {
    id = uuid();
    status = "PENDING"; // enum ShipmentStatuses
    statusHistory = [];
    carrier = null; // shipping carrier name
    trackingNumber = null; // shipment tracking number
    refId = null; // external reference id
    tracking = null; // external tracking history object
    postageCost = 0;

    constructor(shipment) {
        if (isObjectNotEmpty(shipment)) {
            if (isStringNotEmpty(shipment.id)) { this.id = shipment.id; }
            if (isStringNotEmpty(shipment.status)) { this.status = shipment.status; }
            if (isListNotEmpty(shipment.statusHistory)) { this.statusHistory = shipment.statusHistory; }
            if (isStringNotEmpty(shipment.carrier)) { this.carrier = shipment.carrier; }
            if (isStringNotEmpty(shipment.trackingNumber)) { this.trackingNumber = shipment.trackingNumber; }
            if (isStringNotEmpty(shipment.refId)) { this.refId = shipment.refId; }
            if (isObjectNotEmpty(shipment.tracking)) { this.tracking = shipment.tracking; }
            if (isNumberGreaterThanOrEqualToZero(shipment.postageCost)) { this.postageCost = shipment.postageCost; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            status: this.status,
            statusHistory: this.statusHistory,
            carrier: this.carrier,
            trackingNumber: this.trackingNumber,
            refId: this.refId,
            tracking: this.tracking,
            postageCost: this.postageCost,
        };
    }
};

export default OrderShipment;